module.exports = __webpack_public_path__ + "static/img/icon-add.5eb19fa1.svg";